import React, { useCallback, useEffect } from "react";
import "./App.css";
import CPSRoutes from "./routes";
import { createBrowserRouter, Outlet, RouterProvider, useLocation } from "react-router-dom";
import trackPathForAnalytics from "./firebaseAnalytics/firebaseAnalytics";
import SessionHandler from "routes/SessionHandler";
import MainRoutes from "./routes/MainRoutes";
import AnonymousRoutes from "./routes/AnonymousRoutes";

function App() {
  //setFirebaseAnalytics();
  return (
    <>
      <SessionHandler />
      {/* <CPSRoutes /> */}
      <Outlet />
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <App />,
    children: [MainRoutes, AnonymousRoutes],
  },
]);

export default function Root() {
  return <RouterProvider router={router} />;
}

function setFirebaseAnalytics() {
  const { pathname, search } = useLocation();

  const analytics = useCallback(() => {
    trackPathForAnalytics({
      path: pathname,
      search,
      title: pathname.split("/")[1],
    });
  }, [pathname, search]);

  useEffect(() => {
    analytics();
  }, [analytics]);
}

// export default App;
